export default __webpack_public_path__ + "static/media/354.9c62c8dc.gif";